"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    .PresetDateRangePicker_panel {\n      padding: 0 ", "px 11px;\n    }\n    .PresetDateRangePicker_button {\n      position: relative;\n      height: 100%;\n      text-align: center;\n      background: 0 0;\n      border: 2px solid #00a699;\n      color: #00a699;\n      padding: 4px 12px;\n      margin-right: 8px;\n      font: inherit;\n      font-weight: 700;\n      line-height: normal;\n      overflow: visible;\n      -moz-box-sizing: border-box;\n      box-sizing: border-box;\n      cursor: pointer;\n    }\n    .PresetDateRangePicker_button:active {\n      outline: 0;\n    }\n    .PresetDateRangePicker_button__selected {\n      color: ", ";\n      background: ", ";\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var presentDateRangePicker = function presentDateRangePicker(props) {
  var _props$theme = props.theme,
      palette = _props$theme.palette,
      spacing = _props$theme.spacing;
  return styled_components_1.css(_templateObject(), spacing.unit * 3, palette.text["default"], palette.background["default"]);
};

exports["default"] = presentDateRangePicker;